<label>
  <input type="checkbox" name="checkbox" class="checkbox" [checked]="!!_value" />
  <ng-content></ng-content>
</label>

<span *ngIf="invalid" class="checkbox__error">
  <ng-content select="[checkboxError]"></ng-content>
</span>
